import { keepBrandingForLoginPage } from './sessionBranding';

export default function logoutHandler() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  // Clear agent dashboard persisted state so it does not leak across accounts
  localStorage.removeItem('agentDashboardFilters');
  localStorage.removeItem('agentViewType');
  // The login page keeps this team's white-label look; the next login replaces it.
  keepBrandingForLoginPage();
  window.location.href = '/login';
}
